// ProjectPresentation.js
import React from "react";
import styled from "styled-components";
import Navigation from "../components/Header/nav";
import rhys1 from "./../images/rhys1.png";
import rhys2 from "./../images/rhys2.png";
import TextShift from "../utils/TextShift";
import GitHubButton from "../utils/GitHubButton";
import RevealOnScroll from "../utils/RevealOnScroll";

const PageWrapperStyled = styled.div`
  width: 60%;
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px;

  @media (max-width: 768px) {
    padding: 10px;
    width: 90%;
  }
`;

const TitleContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin-bottom: 2rem;
`;

const TitleWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 2rem 0;
  gap: 1rem;
`;

const Section = styled.section`
  margin-bottom: 2rem;
`;

const SectionTitle = styled.h2`
  font-family: "Maitree", sans-serif;
  font-size: 1.5rem;
  color: #d2d2d2;
  margin: 20px 0;
`;

const ProjectImage = styled.img`
  width: 100%;
  max-width: 600px;
  height: auto;
  margin-bottom: 20px;
`;

const SectionText = styled.p`
  text-align: left;
  font-size: 1rem;
  margin-bottom: 20px;
  font-family: "Maitree", sans-serif;
  color: #b5b5b5;
  line-height: 1.6;

  ul {
    list-style-type: none;
    padding-left: 0;
  }

  li {
    margin-bottom: 1rem;
  }

  strong {
    color: #d2d2d2;
  }
`;

const Rhys = () => {
  return (
    <div>
      <PageWrapperStyled>
        <RevealOnScroll>
          <TitleWrapper>
            <TextShift 
              text="Rhys Bot" 
              fontFamily="moret-variable"
              fontSize="2rem"
            />
            <GitHubButton href="https://github.com/PinknMatter/Rhys-Bot" />
          </TitleWrapper>
        </RevealOnScroll>

        <Section>
          <SectionTitle>Overview</SectionTitle>
          <SectionText>
            Rhy's Bot, a custom Discord bot designed to automate and streamline
            operations for ski and snowboard clubs. Initially developed for the
            Concordia Ski and Snowboard Club, this bot represents a significant
            leap in managing team logistics and data handling with efficiency and
            ease. Built on JavaScript and Node.js, leveraging the Discord.js
            library, Rhy's Bot is engineered to tackle the specific challenge of
            parsing and managing CSV files. This choice was driven by the
            necessity to work within the constraints of a pre-existing website
            setup, which offered limited data access without substantial fees. My
            solution was to automate the data extraction and management process
            directly from the platform, enabling seamless handling of ticket sales
            and buyer information.
          </SectionText>
          <ProjectImage src={rhys1} alt="Rhys Bot Interface" />
        </Section>

        <Section>
          <SectionTitle>Core Features</SectionTitle>
          <SectionText>
            <ul>
              <li>
                <strong>Automated Data Management:</strong> Rhy's Bot automates
                the ingestion and parsing of CSV files containing ticket sales and
                customer information. This system allows for efficient tracking of
                sales metrics, total revenue, and the distribution of ticket
                types.
              </li>
              <li>
                <strong>Ticket Transfer Handling:</strong> The bot simplifies the
                ticket transfer process by tracking changes through order IDs,
                ensuring that ticket ownership is accurately updated in the club's
                records.
              </li>
              <li>
                <strong>Digital Bus Lists:</strong> Replacing paper lists, the
                bot's digital bus list feature allows for real-time, multiple
                check-ins, enhancing the departure and arrival processes. This
                feature not only speeds up operations but also improves accuracy
                and accessibility of passenger information.
              </li>
            </ul>
          </SectionText>
          <ProjectImage src={rhys2} alt="Rhys Bot Features" />
        </Section>

        <Section>
          <SectionTitle>Impact</SectionTitle>
          <SectionText>
            Rhy's Bot has transformed the way the team manages its operations,
            from ticket sales to day-of-event logistics. This project highlights
            the potential of tailored software solutions to address niche
            problems. It stands as a testament to the power of combining technical
            skills with personal passions to create practical, impactful tools.
          </SectionText>
        </Section>
      </PageWrapperStyled>
    </div>
  );
};

export default Rhys;
